<template>
<div class='vx-col w-full mt-4'>
    <div class="vx-row">
        <div class="vx-col w-1/2">
            <vs-input class="w-full" ref="input_codigo" tabindex="-1" label-placeholder="Ingresa el código del juego" v-model="datos.txt_codigo" @keyup.enter="f_agregar" />
        </div>
        <div class="vx-col w-1/2 mt-4">
            <vs-button icon="code" @click="f_agregar()">Agregar</vs-button>
        </div>
    </div>
</div>
</template>

<script>
import GeneralMixin from '@/mixins/GeneralMixin';
export default {
    mixins: [GeneralMixin],
    components: {},
    data() {
        return {
            datos: {
                usuario: [],
            },
        };
    },
    created() {},
    mounted() {
        let me = this;
        me.f_inicio();
    },
    methods: {
        f_inicio() {
            let me = this;
            this.usuario = JSON.parse(localStorage.getItem('usuario'))[0];
            // console.log(me.usuario);
            me.datos.txt_codigo = '';
        },
        f_agregar() {
            let me = this;
            let codigo = me.datos.txt_codigo;
            if (codigo.trim() === '') {
                me.f_notificaciones("Ingrese un código de juego", "danger");
                return;
            }
            let formDatos = new FormData();
            formDatos.append('codigo', me.datos.txt_codigo)
            formDatos.append('id_usuario', me.usuario.idusuario)
            formDatos.append('id_grupo', me.usuario.id_group)
            me.$http.post(this.$server_url + 'add_juegos', formDatos)
                .then(function (response) {
                    // console.log(response.data)
                    if (response.data.estado == 0) {
                        me.f_notificaciones(response.data.mensaje, "danger");
                    }
                    if (response.data.estado == 1) {
                        me.f_notificaciones(response.data.mensaje, "warning");
                    }
                    if (response.data.estado == 2) {
                        me.f_notificaciones(response.data.mensaje, "success");
                        me.datos.txt_codigo = '';
                        me.$emit("getMisJuegos")
                    }
                })
                .catch(function (error) {
                    console.log(error)
                });
        },
        
    }
};
</script>
